<ppg-cta-card-template
  class="h-full w-full"
  [url]="largeInformationGeneralCard().content.cta?.content?.url ?? ''"
  [target]="largeInformationGeneralCard().content.cta?.content?.target"
  [template]="largeInformationGeneralCardTemplateRef"></ppg-cta-card-template>
<ng-template #largeInformationGeneralCardTemplateRef>
  <p-card
    [title]="largeInformationGeneralCard().content.headline"
    pAnimateOnScroll
    enterClass="fadein"
    once="false"
    class="h-full block animation-duration-2000 animation-ease-in-out large-information-card"
    [class]="{
      'card-cta-hover': largeInformationGeneralCard().content.cta,
      'card-cta-shadow': largeInformationGeneralCard().content.cta,
      'card-max-width': !isResponsive(),
    }">
    <div class="card-title">
      <ppg-card-title [title]="largeInformationGeneralCard().content.headline"></ppg-card-title>
      <ppg-card-arrow-up-right
        [target]="largeInformationGeneralCard().content.cta?.content?.target"></ppg-card-arrow-up-right>
    </div>
    <div class="card-description">
      <ppg-card-description [description]="largeInformationGeneralCard().content.content"></ppg-card-description>
    </div>
  </p-card>
</ng-template>
